import { SpiralSpinner } from "react-spinners-kit";
export default () => {
  return (
    <div className="loading">
      <SpiralSpinner backColor="#BFDEFA" frontColor="#3297EE" size={60} />
    </div>
  );
};
